import HeroSection from "@/components/HeroSection";
import ServicesGrid from "@/components/ServicesGrid";
import PhilosophySection from "@/components/PhilosophySection";
import InnovationTeaser from "@/components/InnovationTeaser";

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <ServicesGrid />
      <PhilosophySection />
      <InnovationTeaser />
    </main>
  );
}
